import type { ComponentProps } from 'react'

import { Radio as RadioBase, iconButtonClasses, styled } from '@mui/material'

const StyledRadio = styled(RadioBase)(({ theme }) => ({
  color: theme.palette.grey[800],
  margin: -9,
  marginRight: 9,

  [`&.${iconButtonClasses.root}`]: {
    marginRight: 0,

    '&.Mui-checked': {
      color: theme.palette.primary.main,
    },
  },

  '& .MuiIconButton-label': {
    width: theme.spacing(3),
    height: theme.spacing(3),
  },
}))

export const Radio = (props: ComponentProps<typeof RadioBase>) => {
  const { color = 'primary', ...rest } = props

  return <StyledRadio color={color} {...rest} />
}
